import { cn } from "@/lib/utils";

type GameStatus = 'scheduled' | 'live' | 'in_progress' | 'finished' | 'completed' | string;

interface QuickChipsProps {
  gameStatus: GameStatus;
  onChipClick: (text: string) => void;
  disabled?: boolean;
}

const PRE_LIVE_CHIPS = [
  "What's the main pick?",
  "Why this favorite?",
  "Expected goals?",
  "Key stats to watch?",
];

const LIVE_CHIPS = [
  "Current game state?",
  "Who's playing best?",
  "Second half prediction?",
  "What to expect next?",
];

const POST_GAME_CHIPS = [
  "What happened?",
  "How did picks perform?",
  "Key turning points?",
  "Stats summary",
];

export function QuickChips({ gameStatus, onChipClick, disabled }: QuickChipsProps) {
  const isLive = gameStatus === 'live' || gameStatus === 'in_progress';
  const isFinished = gameStatus === 'finished' || gameStatus === 'completed';
  
  const chips = isLive ? LIVE_CHIPS : isFinished ? POST_GAME_CHIPS : PRE_LIVE_CHIPS;

  return (
    <div className="flex flex-wrap gap-2 pb-2">
      {chips.map((chip) => (
        <button
          key={chip}
          onClick={() => onChipClick(chip)}
          disabled={disabled}
          className={cn(
            "px-3 py-1.5 text-xs rounded-full border transition-all",
            "bg-[hsl(var(--sg7-surface-2))] border-[hsl(var(--sg7-stroke-subtle))]",
            "text-[hsl(var(--sg7-text-secondary))] hover:text-[hsl(var(--sg7-text-primary))]",
            "hover:border-[hsl(var(--sg7-gold))] hover:bg-[hsl(var(--sg7-surface-1))]",
            "disabled:opacity-50 disabled:cursor-not-allowed",
          )}
        >
          {chip}
        </button>
      ))}
    </div>
  );
}
